import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  LiveFilter } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';
import { SnackBarContext } from "../../context/SnackbarContext";

import { Header, Results,AddPrice } from './components';
import { Backdrop, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const LivePrices = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const [wholeorders, setWholeorders] = useState([]);
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  const [isadd, setIsadd] = useState(false);
  const [liveobj, setLiveobj] = useState({});
  const [totalCount, setTotalcount] = useState(0);
  const [page, setPage] = useState(0);
  const [masters, setMasters] = useState({});
  const [filtervalue, setFiltervalue] = useState({});
  const [isloading, setIsloading] = useState(true);

  
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const snackbarCtx = React.useContext(SnackBarContext);

  useEffect(() => {
    fetchallprices()
    fetchmasters()
  //  setOrders([{
  //   product: {
  //     productname : "TUTICORIN PORT PALMOLEIN OIL"

  //   },
  //   rangestart : 1000,
  //   rangeend : 1500,
  //   price_diff : '-500'
  //  }])
  }, []);

  async function fetchmasters() {
    let commodities = await sendNetworkRequest('/admin/getparentcommodity', {}, {}, true)
    let languages = await sendNetworkRequest('/admin/getactivelanguages', {}, {}, true)
    setMasters({
      ...masters,
      languages: languages.module,
      commodity: commodities.module

    })
  }
  async function updateprice(liveobj)
  {
    let url = '/admin/addliveprice';
    if(liveobj.live_price_id)
    {
      url = '/admin/editliveprice';
      
    }
     let adminusers = await sendNetworkRequest(url, {}, liveobj,false)
     setIsadd(false)
    snackbarCtx.setSnack({
      ...snackbarCtx,
      open: true,
      type: adminusers.status,
      msg: adminusers.message,
      vertical: "top",
    });
    fetchallprices({
      ...filtervalue,
    })
  }
  function onPagelimitchange(pagelimit)
  {
    setRowsPerPage(pagelimit)

  }
  function onPagechange(page)
  {
    setPage(page)

  }
  async function dismiss()
  {

    setIsadd(false)
  }
  function addprice(priceobj){
    let liveprice_history = {}
      if(priceobj && priceobj.live_prices && priceobj.live_prices.length > 0){
        liveprice_history = {
          ...priceobj.live_prices[0]
        }
      }
      setLiveobj({
            product_id : priceobj.id,
            name : priceobj.name,
            price_start : liveprice_history?.price_start,
            price_end : liveprice_history?.price_end,
            isRange : liveprice_history?.price_end > 0 ? true : false
      })
 
    setIsadd(true)
  }

  async function deleteprice(priceobj){
  if(priceobj.live_prices && priceobj.live_prices.length > 0)
  {
  let bodyparams = {
    product_id : priceobj.id,
    live_price_id : priceobj.live_prices[0].id
  }
  let adminusers = await sendNetworkRequest('/admin/deleteliveprice', {}, bodyparams,false)
  snackbarCtx.setSnack({
    ...snackbarCtx,
    open: true,
    type: adminusers.status,
    msg: adminusers.message,
    vertical: "top",
  });
   fetchallprices({
    ...filtervalue,
   })
} 
}
  function editprice(priceobj)
  {
    let liveprice_history = {}
    if(priceobj && priceobj.live_prices && priceobj.live_prices.length > 0)
    {
      liveprice_history = {
        ...priceobj.live_prices[0]
      }
    }
    setLiveobj({
          live_price_id: liveprice_history.id,
          product_id: priceobj.id,
          name: priceobj.name,
          price_start: liveprice_history.price_start,
          price_end: liveprice_history.price_end,
          price_difference: liveprice_history.price_difference,
          isRange: liveprice_history.price_end > 0 ? true : false
    })
    setIsadd(true)
  }
  function onSearch(key, value)
  {
    setFiltervalue(values => ({
      ...filtervalue,
      [key]: value
    }));
    fetchallprices({
      ...filtervalue,
      [key]: value
    })
  }
  async function fetchallprices(value)
  {
    let bodycontent = {
      offset : page * rowsPerPage,
      limit : rowsPerPage
    }
    if(value)
    {
      bodycontent = {
        ...bodycontent,
        ...value
      }
    }

    let adminusers = await sendNetworkRequest('/admin/getliveprices', {}, bodycontent,false)
    setWholeorders(adminusers?.module)
    setIsloading(false)
    setOrders(adminusers?.module)
    setTotalcount(adminusers?.module?.length??0)
    
  }

  function onLocalsearch(searchtxt)
  {
    
    var filterobj = wholeorders.filter(function (entry) {
      let price_start = "";
      let price_end = "";
      
      if(entry.live_prices?.length > 0)
      {
        let price_obj = entry.live_prices[0]

        price_start = price_obj?.price_start +'';
        price_end = price_obj?.price_end + "";

      }
      return entry.name.toLowerCase().indexOf(searchtxt.toLowerCase()) > -1 || price_start.toLowerCase().indexOf(searchtxt.toLowerCase()) > -1 || price_end.toLowerCase().indexOf(searchtxt.toLowerCase()) > -1;
  });

  setPage(0)
  setOrders([...filterobj])

  }
  return (
    <>
   
    
    <Page
      className={classes.root}
      title="Live Prices"
    >
            
      <Header />
      {isadd ? <AddPrice onUpdate={updateprice}  onDismiss={dismiss} liveobj={liveobj}/> : null }

       <LiveFilter  masters={masters} onSearch={onSearch}/> 
       
       
       {isloading ?  <CircularProgress color="primary" /> : 

      <Results
        className={classes.results}
        orders={orders} //
        onLocalsearch={onLocalsearch}
        totalCount={orders.length}
        onAdd={addprice}
        onEdit={editprice}
        onDelete={deleteprice}
        page={page}
        onPagechange={onPagechange}
        onPagelimitchange={onPagelimitchange}
        rowsPerPage={rowsPerPage}
      />}
     
    </Page>
   
    </>
    
  );
});

export default LivePrices;
